/**
 * MIT License
 *
 * Copyright (c) 2023 Jamasp Team <mailto:radmanesh@gmail.com Arman Radmanesh> <mailto:salarirad@gmail.com Salar Rad>
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
import { Alert, Box, Container } from '@mui/material';
import { Outlet } from 'react-router-dom';
import Footer from '../components/layout/Footer';
import { useAlert } from '../context/AlertContext';
const AuthLayout = () => {
    const { alerts } = useAlert();
    //const { loading } = useAuthContext();

    return (
        <Container component="main" maxWidth="sm">
            <Box minHeight="100vh" display="flex" flexDirection="column" >
                <Container sx={{ flexGrow: 1 }} >
                    {/* {loading && <LinearProgress color="secondary" />} */}
                    {alerts.map((alert, index) => (
                        <Alert key={index} severity={alert.type}>
                            {alert.message}
                        </Alert>
                    ))}

                    <Outlet />
                </Container>

                <Footer />
            </Box>
        </Container>


    );
};

export default AuthLayout;
